// Angular Files
import { Component } from "@angular/core";

// Teller Online Library Files
import { TellerOnlineSiteMetadataService } from 'teller-online-libraries/core';

@Component({
    selector: "app-footer",
    template: `
        <public-footer
            [preview]="false"
            [footerLinks]="siteMetadata?.customization?.footerLinksContent">
        </public-footer>
    `,
    host: {
        class: 'footer'
    }
})
export class FooterComponent {
    constructor(
        public siteMetadata: TellerOnlineSiteMetadataService,
    ) {}
}
